const MinitableSeatPositions = {
    2: [
        {
            position: "absolute",
            right: "0.5vw",
            top: "41.2%",
        },
        {
            position: "absolute",
            left: "0.5vw",
            top: "41.2%",
        },
    ],
    3: [
        {
            position: "absolute",
            right: "0.5vw",
            top: "41.2%",
        },
        {
            position: "absolute",
            left: "2vw",
            top: "62.5%",
        },
        {
            position: "absolute",
            left: "2vw",
            top: "21%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "14%",
        },
    ],
    4: [
        {
            position: "absolute",
            right: "7.5vw",
            top: "14%",
        },
        {
            position: "absolute",
            right: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "14%",
        },
    ],
    5: [
        {
            position: "absolute",
            right: "7.5vw",
            top: "14%",
        },
        {
            position: "absolute",
            right: "0.5vw",
            top: "41.2%",
        },
        {
            position: "absolute",
            right: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "14%",
        },
    ],
    6: [
        {
            position: "absolute",
            right: "7.5vw",
            top: "14%",
        },
        {
            position: "absolute",
            right: "0.5vw",
            top: "41.2%",
        },
        {
            position: "absolute",
            right: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "0.5vw",
            top: "41.2%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "14%",
        },
    ],
    7: [
        {
            position: "absolute",
            right: "7.5vw",
            top: "14%",
        },
        {
            position: "absolute",
            right: "2vw",
            top: "21%",
        },
        {
            position: "absolute",
            right: "2vw",
            top: "62.5%",
        },
        {
            position: "absolute",
            right: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "0.5vw",
            top: "41.2%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "14%",
        },
    ],
    8: [
        {
            position: "absolute",
            right: "7.5vw",
            top: "14%",
        },
        {
            position: "absolute",
            right: "2vw",
            top: "21%",
        },
        {
            position: "absolute",
            right: "2vw",
            top: "62.5%",
        },
        {
            position: "absolute",
            right: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "2vw",
            top: "62.5%",
        },
        {
            position: "absolute",
            left: "2vw",
            top: "21%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "14%",
        },
    ],
    9: [
        {
            position: "absolute",
            right: "7.5vw",
            top: "14%",
        },
        {
            position: "absolute",
            right: "2vw",
            top: "21%",
        },
        {
            position: "absolute",
            right: "0.5vw",
            top: "41.2%",
        },
        {
            position: "absolute",
            right: "2vw",
            top: "62.5%",
        },
        {
            position: "absolute",
            right: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "2vw",
            top: "62.5%",
        },
        {
            position: "absolute",
            left: "2vw",
            top: "21%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "14%",
        },
    ],
    10: [
        {
            position: "absolute",
            right: "7.5vw",
            top: "14%",
        },
        {
            position: "absolute",
            right: "2vw",
            top: "21%",
        },
        {
            position: "absolute",
            right: "0.5vw",
            top: "41.2%",
        },
        {
            position: "absolute",
            right: "2vw",
            top: "62.5%",
        },
        {
            position: "absolute",
            right: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "69.5%",
        },
        {
            position: "absolute",
            left: "2vw",
            top: "62.5%",
        },
        {
            position: "absolute",
            left: "0.5vw",
            top: "41.2%",
        },
        {
            position: "absolute",
            left: "2vw",
            top: "21%",
        },
        {
            position: "absolute",
            left: "7.5vw",
            top: "14%",
        },
    ],
};

export default MinitableSeatPositions;